export default __webpack_public_path__ + "static/PayPal-2c042d975a56d3a2a4d6548f31f98566.png";